import { createContext as e } from "react";
//#region src/services/focusRestore/FocusRestoreContext.ts
var t = e(void 0);
//#endregion
export { t as FocusRestoreContext };
